<template>
    <div class="basic_info">
        <tab-list></tab-list>
    </div>
</template>

<script>
import TabList from './TabList.vue';
export default {
    name: 'basic-info',
    components: { TabList },
    data() {
        return { };
    }
};
</script>

<style lang="less">
    .basic_info {
        width: calc(100% - 20px);
        height: calc(100% - 50px);
        overflow: overlay;
        margin: 0 10px 10px 10px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 5px #f2f2f2;
        min-width: 1200px;
        box-sizing: border-box;
        padding: 16px;
        flex: 1 auto;
    }
</style>
